import React from 'react';
import styles from './Card.module.scss';
import type { Props } from './types';
import { CardSize } from '../../types';
import { useTranslation } from '../../context/TranslationContext/TranslationContext';

const Card = React.forwardRef<HTMLDivElement, Props>(
  ({ title, onReadMoreClick, body, showReadMore, size = CardSize.CONTAINED, bodyClassName }, ref) => {
    const { readMore: readMoreText = 'Read more' } = useTranslation();
    const shouldShowReadMore = typeof body === 'string' ? body.length > 100 || showReadMore : showReadMore;

    return (
      <div ref={ref} className={styles[`card--${size}`]} data-testid="card">
        <div className={styles.contentWrapper}>
          <p className={styles.title}>{title}</p>
          <div className={`${styles.body} ${bodyClassName}`}>{body}</div>
        </div>
        {shouldShowReadMore && (
          <button className={styles.readMore} onClick={onReadMoreClick}>
            {readMoreText}
          </button>
        )}
      </div>
    );
  },
);

Card.displayName = 'Card';

export default Card;
